import { render, staticRenderFns } from "./AppLoading.vue?vue&type=template&id=45d26841&scoped=true&"
import script from "./AppLoading.vue?vue&type=script&lang=ts&"
export * from "./AppLoading.vue?vue&type=script&lang=ts&"
import style0 from "./AppLoading.vue?vue&type=style&index=0&id=45d26841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d26841",
  null
  
)

export default component.exports